// Drawing Guess — client registry entry (see ../registry.ts and docs/games-contract.md).

import { Brush } from 'lucide-react';
import { MAX_PLAYERS, MIN_PLAYERS } from '../../../../supabase/functions/games/drawing.ts';
import { DrawingEasel } from './EaselModel';
import { DrawingTable3D } from './DrawingTable3D';
import { DrawingOverlay } from './DrawingOverlay';
import { DrawingVRPanel } from './DrawingVR';
import { DRAWING_RULES } from './drawingRules';
import type { GameClientDef } from '../types';

export const drawingClient: GameClientDef = {
  kind: 'drawing',
  label: 'Drawing Guess',
  blurb: 'Pictionary-style party game for 3–12 — draw on the big easel, everyone races to guess.',
  icon: Brush,
  glyph: '✏',
  category: 'party',
  minPlayers: MIN_PLAYERS,
  maxPlayers: MAX_PLAYERS,
  bots: false,
  host: 'none',
  joinMidGame: true,
  ranking: 'points',
  // No chairs: everyone stands around the easel.
  chairs: [],
  // The easel is ~2.5 m wide; with its legs it stands ~1.2 m deep.
  footprint: { w: 2.8, d: 1.3 },
  nearRadius: 7,
  Furniture: DrawingEasel,
  Table3D: DrawingTable3D,
  Overlay: DrawingOverlay,
  VRPanel: DrawingVRPanel,
  rules: DRAWING_RULES,
};
